/* Emerald — Ignite accessory add-on.
   Loaded once per page (from the cart-drawer upsell snippet) so the click
   handler survives Dawn's AJAX cart re-renders — inline scripts injected via
   innerHTML during a section re-render do not execute, which is why the button
   was previously dead after adding Ignite. Single-select (one discounted
   accessory per order) is enforced server-side in the Liquid snippet. */
(function () {
  if (window.__enAddonBound) return;
  window.__enAddonBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-en-addon-variant]') : null;
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-en-addon-variant');
    if (!id) return;
    var old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (res) {
      try {
        var parser = new DOMParser();
        if (res.sections && res.sections['cart-drawer']) {
          var nd = parser.parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
          var cd = document.querySelector('cart-drawer');
          if (nd && cd) { cd.innerHTML = nd.innerHTML; cd.classList.remove('is-empty'); }
        }
        if (res.sections && res.sections['cart-icon-bubble']) {
          var nb = parser.parseFromString(res.sections['cart-icon-bubble'], 'text/html').body.firstElementChild;
          var cb = document.getElementById('cart-icon-bubble');
          if (nb && cb) cb.innerHTML = nb.innerHTML;
        }
      } catch (err) {}
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = old;
    });
  });
})();

/* Emerald — Supergreens PDP: mirror the Supergreens purchase selection onto the
   Ignite cross-sell card (blueprint: "same subscribe offer for Ignite").
   • Supergreens on Subscribe & Save → offer Ignite on its MATCHING subscription
     tier (1 pouch £29.99/mo, 2 pouch £55.98/mo, 3 pouch £80.97/mo) and add it on
     the matching Ignite selling plan + quantity.
   • Supergreens one-time → offer Ignite at full price (£34.99), no discount.
   No discount objects — all pricing comes from Ignite's existing selling plans.
   Adds via an about:blank iframe's unpatched fetch so the Appstle app cannot
   force a different plan (mirrors buy-buttons.liquid). The card markup itself is
   built by emerald-cro.js; here we take over its price line + Add button. */
(function () {
  if (window.__enSysXsellBound) return;
  window.__enSysXsellBound = true;

  var IGNITE_PLANS = { 1: 8629715212, 2: 8629747980, 3: 8629780748 };
  var SUB = {
    1: { now: '£29.99/mo', was: '£34.99',  save: 'Save £5'  },
    2: { now: '£55.98/mo', was: '£69.98',  save: 'Save £14' },
    3: { now: '£80.97/mo', was: '£104.97', save: 'Save £24' }
  };

  var css = document.createElement('style');
  css.textContent =
    '.empz .emerald-xsell__was{color:#9a9a9a;text-decoration:line-through;font-weight:500;font-size:14px;margin-left:8px;}' +
    '.empz .emerald-xsell__save{display:inline-block;background:#dfb02b;color:#11151c;font-size:11px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;border-radius:20px;padding:2px 8px;margin-left:8px;vertical-align:middle;}';
  document.head.appendChild(css);

  function igBase() { return (window.__emIgnite && window.__emIgnite.price) ? window.__emIgnite.price : 3499; }
  function money(p) { return '£' + (p / 100).toFixed(2); }

  function isSubscribe() {
    var checked = document.querySelector('.empz input[name^="empz_pt_"]:checked');
    if (checked) return checked.value === 'subscribe';
    var active = document.querySelector('.empz .empz-pt.active input');
    return active ? active.value === 'subscribe' : false;
  }
  function pouchQty() {
    var q = document.querySelector('.empz .empz-qty.active');
    var n = q ? parseInt(q.getAttribute('data-qty'), 10) : 1;
    return (n === 2 || n === 3) ? n : 1;
  }

  function render(card) {
    var nameEl = card.querySelector('.emerald-xsell__name');
    var subEl = card.querySelector('.emerald-xsell__sub');
    if (!nameEl) return;
    if (isSubscribe()) {
      var m = SUB[pouchQty()];
      nameEl.innerHTML = 'Add Ignite® — ' + m.now +
        '<s class="emerald-xsell__was">' + m.was + '</s>' +
        '<span class="emerald-xsell__save">' + m.save + '</span>';
      if (subEl) subEl.textContent = 'Subscribe & Save — matched to your Supergreens plan. Pause or cancel anytime.';
    } else {
      nameEl.textContent = 'Add Ignite® — ' + money(igBase());
      if (subEl) subEl.textContent = 'Energy, focus & endurance — layered on Supergreens.';
    }
  }

  function addIgnite(btn) {
    var g = window.__emIgnite;
    if (!g || !g.vid) return;
    var sub = isSubscribe();
    var qty = pouchQty();
    var body = sub
      ? { id: g.vid, quantity: qty, selling_plan: IGNITE_PLANS[qty] }
      : { id: g.vid, quantity: 1 };
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    var f = window.fetch;
    try {
      var ifr = document.createElement('iframe'); ifr.style.display = 'none';
      document.body.appendChild(ifr);
      if (ifr.contentWindow && ifr.contentWindow.fetch) f = ifr.contentWindow.fetch.bind(ifr.contentWindow);
    } catch (e) {}
    var origin = window.location.origin;
    f(origin + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status && res.description) { throw new Error(res.description); }
      return window.fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
    }).then(function (sec) {
      try {
        var parser = new DOMParser();
        if (sec && sec['cart-drawer']) {
          var nd = parser.parseFromString(sec['cart-drawer'], 'text/html').querySelector('cart-drawer');
          var cd = document.querySelector('cart-drawer');
          if (nd && cd) { cd.innerHTML = nd.innerHTML; cd.classList.remove('is-empty'); }
        }
        if (sec && sec['cart-icon-bubble']) {
          var nb = parser.parseFromString(sec['cart-icon-bubble'], 'text/html').body.firstElementChild;
          var cb = document.getElementById('cart-icon-bubble');
          if (nb && cb) cb.innerHTML = nb.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) { if (typeof drawer.open === 'function') drawer.open(); else { drawer.classList.add('active', 'animate'); document.body.classList.add('overflow-hidden'); } }
      } catch (e) {}
      btn.disabled = false; btn.textContent = 'Added ✓';
      setTimeout(function () { btn.textContent = 'Add'; }, 2000);
    }).catch(function () { btn.disabled = false; btn.textContent = old; });
  }

  var boundCard = null, obs = null, iv = null, tries = 0;
  function stopSeek() { if (obs) { obs.disconnect(); obs = null; } if (iv) { clearInterval(iv); iv = null; } }
  function takeOver() {
    var card = document.querySelector('.empz .emerald-xsell');
    if (!card) return false;
    if (!card.dataset.sysBound) {
      var oldBtn = card.querySelector('.emerald-xsell__cta');
      if (oldBtn) {
        var newBtn = oldBtn.cloneNode(true);
        oldBtn.parentNode.replaceChild(newBtn, oldBtn);
        newBtn.addEventListener('click', function () { addIgnite(newBtn); });
      }
      card.dataset.sysBound = '1';
      boundCard = card;
      render(card);
    }
    stopSeek();
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.empz')) {
      setTimeout(function () { if (boundCard) render(boundCard); }, 60);
    }
  });
  document.addEventListener('change', function () {
    setTimeout(function () { if (boundCard) render(boundCard); }, 60);
  });

  obs = new MutationObserver(function () { takeOver(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', takeOver);
  iv = setInterval(function () { if (takeOver() || (++tries > 60)) { if (tries > 60) stopSeek(); } }, 200);
})();
